import { useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { TransactionWarnings } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import {
  setBlacklistData,
  setBlacklistDataVisible,
  setBlacklistDataItem,
  setBlacklistItemVisible,
  changePanelState,
} from '../../../store/slices/problem-transactions/outgoing-transaction';
import useProblemOutgoingTransaction from '../hooks/use-outgoing';

const OutgoingTransactionWarning = (): React.JSX.Element => {
  const { warnings, senderCompanyOfficials, transaction, chats } =
    useAppSelector((state) => state.customersProblemTransactions.outgoing);
  const { customersTransactionTypes, currentEmployee } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList } = useAppSelector((state) => state.root);

  const dispatch = useAppDispatch();

  const { sendMessage } = useOutletContext<{
    sendMessage: SendMessage | null;
  }>();

  const { transactionId } = useParams();

  const {
    getSenderAccounts,
    chatCreateInProgress,
    createChatWithMessage,
    getOutgoingTransactionWarningByIdAction,
    isWarningByIdLoading,
    isWarningByIdFetching,
  } = useProblemOutgoingTransaction({
    transactionId,
    transaction,
    currenciesList,
    currentEmployee,
    sendMessage,
  });

  useEffect(() => {
    if (
      transaction &&
      transaction.senderAccount &&
      transaction.senderAccount?.organization?.type === 'CORPORATE' &&
      !senderCompanyOfficials
    ) {
      getSenderAccounts(transaction.senderAccount.organizationId);
    }
  }, [transaction, senderCompanyOfficials]);

  return (
    <TransactionWarnings
      warnings={warnings}
      employee={undefined}
      transactionsTypes={customersTransactionTypes}
      setBlacklistDataVisible={(visible) => {
        dispatch(setBlacklistDataVisible(visible));
        dispatch(changePanelState({ state: false }));
      }}
      setBlacklistData={(data) => dispatch(setBlacklistData(data))}
      setBlacklistItemVisible={(visible) => {
        dispatch(setBlacklistItemVisible(visible));
        dispatch(changePanelState({ state: false }));
      }}
      setBlacklistDataItem={(data) => dispatch(setBlacklistDataItem(data))}
      transactionUrlType="outgoing"
      transactionId={transactionId}
      companyOfficials={senderCompanyOfficials}
      individualCustomer={transaction?.senderAccount}
      chats={chats}
      createChatWithMessage={createChatWithMessage}
      chatCreateInProgress={chatCreateInProgress}
      getWarningById={getOutgoingTransactionWarningByIdAction}
      isWarningByIdLoading={isWarningByIdLoading}
      isWarningByIdFetching={isWarningByIdFetching}
      withTransactionUrl
    />
  );
};

export default OutgoingTransactionWarning;
